import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  padding: 10px;

  display: grid;
  grid-template-rows: 80% 20%;
`

export const Footer = styled.footer`
  height: 100%;

  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`
